module.exports = __webpack_public_path__ + "img/dynamic_5.a3e598ce.png";